import { ArrowLeft, Compass } from "@phosphor-icons/react";
import { EmptyState, ThemeSelector } from "@charisol-spark/ui";
import { Button } from "@/components/ui/Button";

/**
 * 404 page. Simpler than the frontend app's (no mascot illustration — not
 * worth carrying that asset over for one internal-tool page).
 */
export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4">
      <div className="absolute right-4 top-4">
        <ThemeSelector />
      </div>
      <img src="/full-logo.svg" alt="Spark" className="mb-8 h-16" />
      <div className="w-full max-w-md rounded-2xl border border-border/50 bg-card/80 shadow-xl">
        <EmptyState
          icon={Compass}
          title="Page not found"
          description="The page you're looking for doesn't exist or has been moved."
          action={
            <a href="/">
              <Button variant="outline" pill>
                <ArrowLeft className="mr-2 h-4 w-4" />
                Back to Dashboard
              </Button>
            </a>
          }
        />
      </div>
    </div>
  );
}
